var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"q-px-md"},[_c('q-input',{staticClass:"q-my-lg",attrs:{"type":"text","outlined":"","color":"primary","label":"Audio Noticeboard name:"},model:{value:(_vm.noticeboard_name),callback:function ($$v) {_vm.noticeboard_name=$$v},expression:"noticeboard_name"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }